// First API Layer of Treaty
import { init } from './init'

export const actions = Object.assign({}, init)
